<template>
  <div class="gp-content">
    <content-nav-bar>
      <h5 class="is-size-4 has-text-centered level-item">Edit Action Configuration</h5>
      <a v-on:click="submit()" class="level-item button add">
        <i class="far fa-save"></i>
        Save
      </a>
      <loader class="level-item" :showLoader="showLoader">Saving</loader>
      <p v-if="message" class="level-item message">{{ message }}</p>
    </content-nav-bar>
    <div class="scroll-vertical">
      <action-configs-form
        :action.sync="internalAction"
        :existing="true">
      </action-configs-form>
    </div>
  </div>
</template>

<script>
import ContentNavBar from '@/components/ContentNavBar.vue';
import ActionConfigsForm from '@/components/actions/forms/ActionConfigsForm.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'ActionEdit',
  components: {
    ContentNavBar,
    Loader,
    ActionConfigsForm,
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentAction() {
      return {
        id: this.action.id,
        name: this.internalAction.name,
        description: this.internalAction.description,
        logConfig: JSON.stringify(this.internalAction.logConfig),
        alertConfig: JSON.stringify(this.internalAction.alertConfig),
        cacheConfig: JSON.stringify(this.internalAction.cacheConfig),
      };
    },
  },
  data() {
    return {
      showLoader: false,
      message: null,
      internalAction: this.action,
    };
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const action = await this.$store.dispatch('primary/updateActionConfigs', this.currentAction);
      this.showLoader = false;
      if (action) {
        this.message = 'Action Configuration Saved!';
        // this.$router.push({ name: 'analytics.index.detail', params: { id: analytic.uuid } });
      } else {
        this.message = 'Error Saving!';
      }
    },
  },
};
</script>
